import image1 from "../img/sincerely-media-qzmPDJJOz4c-unsplash.jpg";
import image2 from "../img/sporlab-XiZ7pRvCzro-unsplash.webp";
import image3 from "../img/206-1280x1280.jpg";
import image4 from "../img/436-1280x900.jpg";
import image5 from "../img/1035-1280x760.jpg";

export const images = [image1, image2, image3, image4, image5];
